import React from "react"
import { IProductFooter } from "../gridLayout2/FullWidthPromoModules"
import { Link } from "gatsby"

const ProductBanner: React.FC<IProductFooter> = ({ headline, link }) => {
  return (
    <div className="absolute bottom-0 left-0 w-full rounded-b bg-darkBlue bg-opacity-[.85] py-[13px]">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between px-[20px]">
        <h4 className="mt-[5px] leading-[30px]">{headline}</h4>
        {link && (
          <Link
            to={link?.url}
            className="text-linkButton text-yellow underline"
          >
            {link?.title}
          </Link>
        )}
      </div>
    </div>
  )
}

export default ProductBanner
